import type { useTranslations } from "next-intl";

export { prettyNumber } from "@repo/utils";

type ListingTitleSource = {
  pitch?: string | null;
  businessType?: { name: string } | null;
  business?: {
    address?: {
      city?: string | null;
      state?: string | null;
    } | null;
  } | null;
};

export function initialsOf(input: string, limit = 2): string {
  return input
    .split(" ")
    .map((word) => word.charAt(0))
    .slice(0, limit)
    .join("")
    .toUpperCase();
}

export function shortName(name: string | null | undefined) {
  if (!name) {
    return "";
  }

  return name.split(" ")[0];
}

export function getListingTitle(
  t: ReturnType<typeof useTranslations>,
  listing: ListingTitleSource,
): string {
  if (listing.pitch) {
    return listing.pitch;
  }

  const shortAddress = listing?.business?.address
    ? `${listing.business.address.city}, ${listing.business.address.state}`
    : null;

  if (!shortAddress || !listing.businessType) {
    return t("saas.listing.header.title.untitled" as any);
  }

  return t("saas.listing.header.title.masked" as any, {
    name: listing.pitch ?? "N/A",
    category: listing.businessType.name,
    address: shortAddress,
  });
}
